import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { useAppContainerContext } from '../AppContainerContext';
import { StoredMessage } from '../chat/types';
import { useSiesta } from '../SiestaProvider';

export function useOpenConversation() {
  const { loadHistory } = useSiesta();
  const { setConversationId, setSiestaMode } = useAppContainerContext();

  return (id: string) => {
    void (async () => {
      try {
        const { data } = await api.get<{ messages: StoredMessage[] }>(`conversations/${id}`);
        setConversationId(id);
        loadHistory(data.messages);
        setSiestaMode('chat');
      } catch (error) {
        notifyAndLogError(
          'Could not open chat',
          'The chat could not be opened. Please try again.',
          error,
        );
      }
    })();
  };
}
